import React from "react";
import { ImageUploader } from "ui/pages/TemplatePreview/widgets";
import style from "./../../../style.module.css";
import {
  DEFAULT_INTRO_VIDEO_BG,
  TEMPLATE_KEYS,
} from "ui/pages/TemplatePreview/constants";
import { IMAGE_SECTION_KEY_PATH } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";

export const BackgroundImage = ({
  data,
  set_data,
  slug_value,
  imageParams,
  disableAllEdits,
}) => {
  return slug_value === TEMPLATE_KEYS.UNLOCK ? (
    <div className={style.fieldContainer}>
      <div className={style.label}>Background image</div>
      <div className={style.field}>
        <ImageUploader
          hideRecommendedText
          uploadUrl={
            data?.intro_video_bg || DEFAULT_INTRO_VIDEO_BG?.[slug_value]
          }
          setUploadUrl={(firebaseUrl) => {
            set_data({ ...data, intro_video_bg: firebaseUrl });
          }}
          hoverText="Upload Image"
          fullWidth={imageParams.fullWidth}
          width={imageParams.width}
          height={imageParams.height}
          borderRadius="0%"
          query={"subtle wallpapers"}
          id="website_intro_video_bg"
          disabled={disableAllEdits}
          uploadViaOptimization
          sectionName={IMAGE_SECTION_KEY_PATH.HOME_PAGE}
        />
      </div>
      <div className={style.photoWidgetText}>
        Recommended format: {imageParams.fullWidth}&nbsp;&times;&nbsp;
        {Math.round(imageParams.fullWidth / imageParams.baseAspectRatio)} pixels
        (PNG or JPG)
      </div>
    </div>
  ) : null;
};
